module.exports = __webpack_public_path__ + "static/img/积极共进@2x.d12b4eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/积极共进@2x.png
// module id = Z98r
// module chunks = 0